window.seekdaTracking = () => {
    let _skd = window._skd || {};
    _skd.callbacks = _skd.callbacks || {};
    _skd.callbacks.dsr = _skd.callbacks.dsr || {};

    _skd.callbacks.dsr.offerListInit = () => {
        dataLayer.push({
            event: 'seekdaTrackingOfferListInit'
        });
    };

    _skd.callbacks.dsr.searchBtnClick = () => {
        dataLayer.push({
            event: 'seekdaTrackingSearchBtnClick'
        });
    };

    _skd.callbacks.dsr.searchDataChange = () => {
        dataLayer.push({
            event: 'seekdaTrackingSearchDataChange'
        });
    };

    _skd.callbacks.dsr.viewOffers = () => {
        dataLayer.push({
            event: 'seekdaTrackingViewOffers'
        });
    };

    _skd.callbacks.dsr.viewRoom = data => {
        dataLayer.push({
            dynx_itemid: data.roomId,
            dynx_pagetype: 'offerdetail',
            event: 'seekdaTrackingViewRoom'
        });
    };

    _skd.callbacks.dsr.viewPackage = () => {
        dataLayer.push({
            event: 'seekdaTrackingViewPackage'
        });
    };

    _skd.callbacks.dsr.viewPersInfo = data => {
        dataLayer.push({
            dynx_itemid: data.selectedRoomCodes,
            dynx_pagetype: 'conversionintent',
            dynx_totalvalue: data.total,
            event: 'seekdaTrackingViewPersInfo'
        });
    };

    _skd.callbacks.dsr.viewPayment = () => {
        dataLayer.push({
            event: 'seekdaTrackingViewPayment'
        });
    };

    _skd.callbacks.dsr.viewConfirmation = data => {
        let items = [];
        data.searchData.rooms.forEach((room, index) => {
            items.push({
                id: data.reservationId,
                name: data.selectedRoomCodes[index],
                price: room.roomTotal,
                quantity: '1',
                category: 'Rooms'
            });
        });

        data.selectedPackageCodes.forEach((index, packageCode) => {
            items.push({
                id: data.reservationId,
                name: packageCode,
                category: 'Packages',
                price: data.total,
                quantity: '1'
            });
        });

        dataLayer.push({
            dynx_itemid: data.selectedRoomCodes,
            dynx_pagetype: 'conversion',
            dynx_totalvalue: data.total,
            transactionId: data.reservationId,
            transactionAffiliation: 'Seekda DSR',
            transactionTotal: data.totalWithoutTaxes,
            transactionTax: data.total - data.totalWithoutTaxes,
            transactionShipping: 0,
            transactionProducts: items,
            event: 'seekdaTrackingViewConfirmation'
        });
    };
};
